import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'inputWithViewDetails',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    prefix: {
      type: String,
      default: ''
    },
    clickFun: {
      type: Function
    },
    payload: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      lang: 'en',
    }
  },
  created() {
    this.lang = this.$localStorage.get('_lang');
  },
  methods: {
    viewDetails() {
      this.clickFun(this.payload);
    },
    getButtonStyle() {
      if (this.lang == 'ar') {
        return 'margin-right: -40px';
      } else {
        return 'margin-left: -40px';
      }
    }
  },
}

